import { render } from "./GuessTheBalanceDialog.vue?vue&type=template&id=f22a57e8&scoped=true"
import script from "./GuessTheBalanceDialog.vue?vue&type=script&lang=js"
export * from "./GuessTheBalanceDialog.vue?vue&type=script&lang=js"

import "./GuessTheBalanceDialog.vue?vue&type=style&index=0&id=f22a57e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22a57e8"]])

export default __exports__